import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function Markets() {
  const [markets, setMarkets] = useState([]);

  useEffect(() => {
    api.get('/exchange/markets').then((r) => setMarkets(r.data.markets || [])).catch((error) => {
      toast.error(error.response?.data?.message || 'Failed to load markets');
    });
  }, []);

  return (
    <div className="page-shell page-stack">
      <section className="surface-panel glow-surface" style={{ padding: '1.5rem' }}>
        <div className="section-tag">Tokenized exchange</div>
        <h1 className="section-title">CarbonX Markets</h1>
        <p className="section-copy">Trade tokenized voluntary carbon issuance batches with visible provenance and retirement-aware supply.</p>
      </section>

      <section className="listing-grid">
        {markets.map((market) => (
          <Link key={market.id} to={`/markets/${market.id}`} style={{ textDecoration: 'none' }}>
            <div className="surface-panel listing-card">
              <div className="section-tag">{market.symbol}</div>
              <div className="listing-title" style={{ marginTop: '0.6rem' }}>{market.project_name}</div>
              <div className="listing-copy">{market.methodology_code} · {market.vintage}</div>
              <div className="listing-meta-grid" style={{ marginTop: '1rem' }}>
                <div><div className="meta-label">Last price</div><div className="meta-value">₹{Number(market.last_price || 0).toLocaleString('en-IN')}</div></div>
                <div><div className="meta-label">Circulating</div><div className="meta-value">{Number(market.circulating_supply || 0).toLocaleString('en-IN')}</div></div>
                <div><div className="meta-label">Retired</div><div className="meta-value">{Number(market.retired_supply || 0).toLocaleString('en-IN')}</div></div>
                <div><div className="meta-label">Status</div><div className="meta-value">{market.status}</div></div>
              </div>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
